import(/* webpackMode: "eager" */ "/tmp/8dee8231af5a4f4/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/tmp/8dee8231af5a4f4/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/tmp/8dee8231af5a4f4/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8dee8231af5a4f4/src/components/Header.tsx");
